#import "../fragments/calendar-fragment.graphql"

mutation UpdateCalendarExportRule($calendarId: ID!, $exportRule: CalendarExportRule!) {
    calendarExportRuleUpdate(calendarId: $calendarId, exportRule: $exportRule) {
        calendar {
            ...CalendarFragment
        }
    }
}
